<script>
  import { Router, Link, Route } from "svelte-routing";
  import { fetchSite } from "./toolbox.js";
  import Layout from "./Layout.svelte";
  import Test from "./Test.svelte";

  export let url = "";

  history.pushState = new Proxy(history.pushState, {
      apply (target, thisArg, argumentsList) {
          scrollTo(0,0);
          Reflect.apply(target, thisArg, argumentsList)
      }
  })  
</script>

<main>
  {#await fetchSite()}
  <p>waiting...</p>
  {:then site}
  <Router url="{url}">

    {#each site.pages as page}
      <Route path="{page.slug == 'home' ? '' : page.slug}">
        <Layout page={page} />
      </Route>
    {/each}

    <Route path="test">
      <Test />
    </Route>

  </Router>
  {:catch error}
  <p>Something went wrong: {error.message}</p>
  {/await}
</main>
